export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14489.cc424ce3.jpg";